/* eslint-disable @typescript-eslint/no-floating-promises */
import { useEffect } from 'react'
import ApexCharts from 'apexcharts'
import { IDadoGrafico } from '../..'
import { Flex, Grid, Text } from '@chakra-ui/react'

interface iChartProps {
  model: IDadoGrafico[]
}

export const BarChartGeral: React.FC<iChartProps> = ({ model }) => {
  const id = 'teste'
  const valorOrdenado = model?.sort((a, b) => parseFloat(b.media) - parseFloat(a.media))

  function ObterCor(value: IDadoGrafico[]): string[] {
    const arr: string[] = []
    value?.forEach(e => {
      if (Number(e.media) < 0) {
        arr.push('var(--Orange)')
      } else {
        arr.push('var(--Green2)')
      }
    })

    return arr
  }
  function ObterValorPos(value: IDadoGrafico[]): string[] {
    const arr: string[] = []
    value?.forEach(e => arr.push(e.media))

    return arr
  }

  function GerarGrafico(): void {
    const options = {
      series: [{
        data: ObterValorPos(valorOrdenado)
      }],
      grid: {
        show: false,
        padding: {
          left: 90,
          right: 90
        }
      },
      chart: {
        type: 'bar',
        height: valorOrdenado?.length * 35,
        width: '100%',
        redrawOnParentResize: true,
        toolbar: {
          show: false
        }
      },
      annotations: {
        xaxis: [
          {
            x: 0,
            strokeDashArray: 0,
            borderColor: 'var(--c5)',
            fillColor: '#c2c2c2',
            opacity: 0.8,
            offsetX: 0,
            offsetY: 0
          }
        ]
      },
      dataLabels: {
        enabled: true,
        textAnchor: 'start',
        offsetX: 8,
        offsetY: 0,
        formatter: function (value: any, series: any) {
          return `C${((series.dataPointIndex as number) + 1)} (${valorOrdenado[series.dataPointIndex].media})`
        },
        style: {
          colors: ['#000']
        }
      },
      colors: ObterCor(valorOrdenado),
      plotOptions: {
        bar: {
          horizontal: true,
          distributed: true,
          barHeight: '20px',
          dataLabels: {
            position: 'top'
          }
        }
      },
      legend: {
        show: false
      },
      tooltip: {
        x: {
          show: false
        },
        y: {
          // Sem isso o tooltip usaria o formatter invisivel do yaxis e perderia o valor
          formatter: function (value: any, series: any) {
            return valorOrdenado[series.dataPointIndex].media
          },
          title: {
            formatter: function (value: any, series: any) {
              return valorOrdenado[series.dataPointIndex].nome + ' - '
            }
          },
          marker: {
            show: false
          }
        }
      },
      // Sem categories o ApexCharts 3.40 (versao do build de prod) trata o eixo
      // como numerico e desloca cada rotulo uma faixa acima da sua barra.
      xaxis: {
        type: 'category',
        categories: valorOrdenado?.map((e, i) => `C${i + 1}`),
        labels: {
          show: false
        }
      },
      yaxis: {
        // O ApexCharts 3.40 (build de prod) recua o dataLabel em metade da largura
        // do texto deste formatter e o centraliza pela altura dele. Um espaco de largura
        // zero zera o recuo e mantem a altura da linha, como na 3.54.
        labels: {
          show: false,
          formatter: () => '\u200B'
        },
        max: valorOrdenado.some(e => parseFloat(e.media) > 0.6) ? 1.2 : 0.6,
        min: valorOrdenado.some(e => parseFloat(e.media) < -0.6) ? -1.2 : -0.6
      }
    }

    const chart = new ApexCharts(document.querySelector(`#${id}`), options)
    chart.render()
  }

  useEffect(() => {
    GerarGrafico()
  }, [model])

  return (
    <Flex flexDir={'column'}>
      {/* <Flex direction={'column'} my={'1rem'}>
        <Flex justifyContent={'center'} gap={'.875rem'}>
          <Flex gap={'.325rem'} alignItems={'center'}><Box w={'1.25rem'} h={'1.25rem'} bgColor={'var(--Orange)'}></Box> Competências priorizadas para serem desenvolvidas</Flex>
          <Flex gap={'.325rem'} alignItems={'center'}><Box w={'1.25rem'} h={'1.25rem'} bgColor={'var(--Green2)'}></Box> Demais competências</Flex>
        </Flex>
      </Flex> */}
      <Flex w={'100%'} justifyContent={'center'} position={'relative'}>
        <div id={id} style={{ width: '100%' }}></div>
      </Flex>
      <Grid gridTemplateColumns={'repeat(2, 1fr)'} gap='.5rem' px={'1rem'}>
        {valorOrdenado?.map((e, i) => {
          return (
            <Text key={i}>C{i + 1}. {e.nome} ({e.media})</Text>
          )
        })}
      </Grid>
    </Flex>
  )
}
